import { html } from "lit-html";
import { ModalRecommendJsEnv } from "../../../models/add_cart/modal_recommend_js_env";
import { RrAreaModal } from "./rr_area_modal";

export const RecommendModal = (model: ModalRecommendJsEnv) => html`
${RrAreaModal(model.rrAreaProfileItemModal, model.isLogin, true)}
`;
